module.exports = __webpack_public_path__ + "media/concept_material-d0b012c6f4bb89420458227051c5a2e7.svg";